import React, { useEffect } from 'react';
import {
    Button,
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Card } from 'react-bootstrap';
import { DataTable, Loadable } from '../../../../common';
import { useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { nonPaginatedSorting } from '../../../../util';
import StepThreeGridActionItems from './StepThreeGridActions/StepThreeGridActionItems';
import StepThreePricerDialog from './StepThreePricerDialog/StepThreePricerDialog';

const useStyles = makeStyles(theme => ({
    skipButton: {
        borderColor: '#ffc107',
        backgroundColor: '#ffc107',
        "&:hover": {
            borderColor: '#e0a800',
            backgroundColor: '#e0a800',
        },
    },
}));



interface PayerContractStepProps {
    intl: any;
    history: any;
    activeStep: number;
    processContractsPending: boolean;
    getContractsPending: boolean;
    contractsData: any;
    handleNext: () => void;
    handleBack: () => void;
    handleCallNegotiatedAPI: (bool: boolean) => void;
    order: any;
    sort: any;
    filter: any;
    // selectedItems: any;
    contractsFields: any;
    negotiatedRatesState: {
        value: string;
        updatedBy: string;
        updatedAt: string;
    } | null;
    actions: {
        getPricerConfigContracts: () => void;
        setSort: (value: any) => void;
        setOrder: (value: any) => void;
        setFilter: (value: any) => void;
        setSelected: (value: []) => void;
        processContracts: (payload: any, callback: () => void) => void;
        getConfigNegotiatedRates: (payload: any, callback: () => void) => void;
    };
}

function PayerContractStep({
    intl, history, processContractsPending, getContractsPending, handleNext, handleBack,
    order, sort, filter, contractsFields, contractsData, handleCallNegotiatedAPI,
    actions: { setFilter, setSort, setOrder, getPricerConfigContracts,
        setSelected, processContracts, getConfigNegotiatedRates }
}: PayerContractStepProps & RouteComponentProps) {
    const [isConfirmOpen, setConfirmOpen] = useState(false);
    const [isExecutionDialogOpen, setExecutionDialogOpen] = useState(false);
    const [data, setData] = useState([]);
    const [tableSort, setTableSort] = useState([]);
    const classes = useStyles();

    useEffect(() => {
        getPricerConfigContracts();
        return () => {
            setSelected([]);
        }
    }, [getPricerConfigContracts]);

    const handleRefresh = () => {
        getPricerConfigContracts();
    }

    const handleOpenConfirmDialog = () => {
        setConfirmOpen(true);
    }
    const handleCloseConfirmDialog = () => {
        setConfirmOpen(false);
    }
    const handleDialogConfirmation = (selectedItems) => {
        handleCloseConfirmDialog();
        handleCallNegotiatedAPI(false); // disable API call on 4th step
        const payload = selectedItems;
        processContracts(payload, handleProcessCallback)
    }

    const handleSkip = (selectedItems) => {
        const payload = selectedItems;
        getConfigNegotiatedRates(payload, handleCallback);
    }

    const handleRedirectToExecutionPage = () => {
        setExecutionDialogOpen(false);
        //history.push('/pricer/executions');
    }

    const handleCallback = () => {
        handleNext();
    }
    const handleProcessCallback = () => {
        setExecutionDialogOpen(true);
    }
    const handleSort = (sort) => {
       const {sort:tSort,tableData} =nonPaginatedSorting(sort,[...data])
        setData(tableData);
        setTableSort(tSort);
    };
    
    useEffect(() => {
        setData(contractsData)
    }, [contractsData]);
 
    return (
        (<Loadable loading={processContractsPending || getContractsPending}>
            <Grid item xs={12} className="mt-3">
                <Card>
                    <Card.Header as="h5" className='text-center'>Contracts</Card.Header>
                    <Card.Body className='text-dark px-5 py-4'>
                        <Grid container>
                            <Grid item md={12} className="col-md-12">
                                <DataTable
                                    name="pricer-config-contracts-landing"
                                    fields={contractsFields}
                                    data={data}
                                    handleRefresh={handleRefresh}
                                    defaultSort={[]}
                                    loading={false}
                                    title="Contracts"
                                    order={order}
                                    onOrder={setOrder}
                                    sort={tableSort}
                                    onSort={handleSort}
                                    stickyHeader={true}
                                    hasCheckbox={true}
                                    showSelectAll={contractsData.some(contract => contract.disabledCheckbox === true) ? false : true}
                                    pageName="pricer-config-contracts-landing"
                                    shouldRenderLazy={true}
                                />
                            </Grid>
                        </Grid>

                        <StepThreeGridActionItems
                            handleBack={handleBack}
                            handleSkip={handleSkip}
                            processContractsPending={processContractsPending}
                            classes={classes}
                            handleOpenConfirmDialog={handleOpenConfirmDialog}
                            />
                    
                    </Card.Body>
                </Card>
            </Grid>
            <StepThreePricerDialog
                isConfirmOpen={isConfirmOpen}
                handleCloseConfirmDialog={handleCloseConfirmDialog}
                handleDialogConfirmation={handleDialogConfirmation}
                />
            <Dialog
            fullWidth
            scroll="paper"
            maxWidth="sm"
            open={isExecutionDialogOpen}
            aria-labelledby="form-dialog-title">
            <DialogContent className='p-4'>
            <Grid container className='pt-2'>
                <Grid>
                    <p> Your request has been submitted. Please check in the execution logs page. </p>
                </Grid>
                </Grid>
                <Grid container className='justify-content-end pt-3'>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleRedirectToExecutionPage}
                    >
                        OK
                    </Button>
                </Grid>
            </DialogContent>
        </Dialog>
        </Loadable>)
    );
}
export default withRouter(PayerContractStep)